import Vue from "vue";
import App from "@/App.vue";
import router from "@/router";
import store from "@/store";
import VueI18n from "vue-i18n";
import locales from "@/locales";
import { Settings } from "luxon";

import hagerKostenubernahmen from "./static/kostenuebernahmen.hager";
import cliniusKostenubernahmen from "./static/kostenuebernahmen.clinius";
import cliniusChKostenubernahmen from "./static/kostenuebernahmen.cliniusCh";
import { SET_KOSTENUEBERNAHMEN } from "./store/mutations.type";


import filter from "./util/filter";
import plugins from "./plugins";
import components from "./components";
/* ---- FONT AWESOME EINBINDUNG ----
https://github.com/FortAwesome/vue-fontawesome
*/

/* ---- ENDE FONT AWESOME EINBINDUNG ---- */

Vue.config.productionTip = false;

Vue.use(VueI18n);

components.setup(Vue)

filter.setUp(Vue);

plugins.setUp(Vue)

var use_locale = "de"
if (navigator.bx_sprache) {
  use_locale = navigator.bx_sprache;
}

var i18n = null

if (process.env.VUE_APP_CLINIUS_CH && process.env.VUE_APP_CLINIUS_CH==1) {
  i18n = new VueI18n({
    locale: use_locale,
    fallbackLocale: "de",
    messages: locales.messages["clinius_ch"],
    dateTimeFormats: locales.dateTimeFormats,
  });
} else {
  i18n = new VueI18n({
    locale: use_locale,
    fallbackLocale: "de",
    messages: locales.messages[process.env.VUE_APP_CUSTOMER],
    dateTimeFormats: locales.dateTimeFormats,
  });
}


Settings.defaultZoneName ="Europe/Berlin";

if (process.env.VUE_APP_CUSTOMER === 'hager') {
  store.commit(SET_KOSTENUEBERNAHMEN, hagerKostenubernahmen);
} else {
  if (process.env.VUE_APP_CLINIUS_CH === "1") {
    store.commit(SET_KOSTENUEBERNAHMEN, cliniusChKostenubernahmen);
  } else {
    store.commit(SET_KOSTENUEBERNAHMEN, cliniusKostenubernahmen);
  }
}

App.i18n = i18n
App.router = router
App.store = store

let widgetNode = 'online-terminbuchung-widget';

if (document.getElementsByTagName(widgetNode).length === 0) {
  let widget = document.createElement(widgetNode);
  document.body.appendChild(widget);
}

Vue.customElement(widgetNode, App);





